$(document).ready(function () {    
    if (sessionStorage.blogFeed) {
        $('.blogfeed #newsWrapper').append(sessionStorage.blogFeed);
        mh_remove();
    } else {
        $.ajax({
            type: "GET",
            dataType: "html",
            url: "/blog/",
            success: function(e) {
             
                var a = shoptet.common.createDocumentFromString(e),
               
                    t = $(a).find(".news-wrapper").html();
                    
                if (t) {
                    $(".blogfeed #newsWrapper").html(t);
                    mh_remove();
                    sessionStorage.blogFeed = t;
                } else {
                    console.warn('Prvek #newsWrapper není v odpovědi nalezen.');
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('Chyba při načítání blogu:', textStatus, errorThrown);
            }
        });
    }
});

if($('.type-posts-listing').length){
    $('.news-item a.title').each(function() {
        var $this = $(this);
        var href = $this.attr('href');
        var $newsItem = $this.closest('.news-item');
        var $text = $newsItem.find('.text');
        if (href && $text.length) {
            $text.append('<span class="link"><a href="' + href + '">Přečíst celé</a></span>');
        } else {
        }
    });
};

function mh_remove() {
        $('.blogfeed #newsWrapper .news-item').not(":nth-child(-n+3)").remove();
        $('.in-index .news-item a.title').each(function() {

            var $this = $(this);
            var href = $this.attr('href');
            var $newsItem = $this.closest('.news-item');
            var $text = $newsItem.find('.text');
            var $img = $newsItem.find('img');
            var imgSrc = $img.attr('data-src');
           
            if (href && $text.length) {
                $text.append('<span class="link"><a href="' + href + '">Přečíst celé</a></span>');
                $img.attr('src', imgSrc);
            } else {
                console.warn('Chybějící atribut nebo prvek:', {
                    href: href,
                    textLength: $text.length,
                    imgLength: $img.length,
                    imgSrc: imgSrc
                });
            }
        });
    }